import React from 'react';
import { 
  Bell, 
  Clock,
  Trash2,
  Edit
} from 'lucide-react';
import { Badge, Tooltip, Switch } from 'antd';

const AlarmCard = ({ alarm, onClick, onDelete, onToggle, onViewNotifications }) => {
  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(alarm.alarmId);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    // Implement edit functionality
  };

  const handleViewNotifications = (e) => {
    e.stopPropagation();
    onViewNotifications(alarm.alarmId);
  };

  return (
    <div className="relative group">
      <div 
        onClick={onClick}
        className="bg-white rounded-xl shadow-sm hover:shadow-lg border border-gray-200 overflow-hidden cursor-pointer transition-all duration-200 w-full"
      >
        {/* Top status border */}
        <div className={`h-1 w-full ${alarm.isActive ? 'bg-green-100' : 'bg-red-300'}`}></div>

        {/* Card Body */}
        <div className="p-6 space-y-3">
          {/* Header with Alarm Name */}
          <h3 className="text-lg font-semibold text-gray-800 break-words whitespace-normal">
            {alarm.name}
          </h3>

          {/* Description */}
          {alarm.description && (
            <p className="text-sm text-gray-600 line-clamp-2">
              {alarm.description}
            </p>
          )}

          {/* Last checked time */}
          <div className="text-xs text-gray-500 flex items-center">
            <Clock className="w-3 h-3 mr-1" />
            <span>Last checked: {new Date(alarm.lastChecked).toLocaleString()}</span>
          </div>
        </div>

        {/* Footer with Notification and Toggle */}
        <div className="px-6 py-3 bg-gray-50 border-t border-gray-100">
          <div className="flex justify-between items-center">
            {/* Notification Button */}
            <button 
              onClick={handleViewNotifications}
              className="flex items-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors relative"
            >
              <div className="relative">
                <Bell className="w-5 h-5" />
                {alarm.unreadCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                    {alarm.unreadCount > 9 ? '9+' : alarm.unreadCount}
                  </span>
                )}
              </div>
              <span className="ml-2">Notifications</span>
            </button>

            {/* Toggle Switch */}
            <div onClick={(e) => e.stopPropagation()}>
              <Tooltip title={alarm.isActive ? "Deactivate" : "Activate"}>
                <Switch 
                  checked={alarm.isActive} 
                  onChange={() => onToggle(alarm.alarmId, alarm.isActive)}
                  className={alarm.isActive ? "bg-green-500" : "bg-gray-300"}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      {/* Edit/Delete buttons (shown on hover) */}
      {!alarm?.isActive && (
        <div className="absolute -top-3 -right-3 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
          <button 
            onClick={handleEdit}
            className="p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors duration-200"
            aria-label="Edit alarm"
          >
            <Edit className="w-4 h-4 text-blue-600" />
          </button>
          <button 
            onClick={handleDelete}
            className="p-2 bg-white rounded-full shadow-md hover:bg-red-50 transition-colors duration-200"
            aria-label="Delete alarm"
          >
            <Trash2 className="w-4 h-4 text-red-600" />
          </button>
        </div>
      )}
    </div>
  );
};

export default AlarmCard;